import React, { forwardRef, useImperativeHandle, useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../Context/LanguageContext';

// import DefaultLogoPath from '../../image/DefaultLogo.png'
import DefaultLogoPath from '../../image/DefaultLogo.svg'
import { ReactComponent as EditSvg } from '../../image/Edit.svg'

export default function ProfileInput(props) {
  const { imgBase64, setImgBase64 } = props;
  const { t } = useLanguage();
  
  const [imgFile, setImgFile] = useState();
  const [isUpLoad, setIsUpLoad] = useState(false);
  const [imgLocalPath, setImgLocalPath] = useState('');
  const [isErrorProfile, setIsErrorProfile] = useState(false);

  const hiddenFileInput = useRef(null);
  const FileInputRef = useRef();

  // useImperativeHandle(ref, () => ({
  //   getImgBase64: () => {
  //     return imgBase64;
  //   },
  //   setImgBase64: (val) => {
  //     setImgBase64(val);
  //     setIsUpLoad(true);
  //     setIsErrorProfile(false);
  //   },
  //   setImageFile: (val) => {
  //     setImgFile(val);
  //   },
  //   getValue: () => {
  //     return imgLocalPath;
  //   },
  //   reset: () => {
  //     setImgBase64();
  //     // setImgFile();
  //     setImgLocalPath();
  //     setIsErrorProfile(false);
  //   }
  // }));

  // 사진 변경시 에러 코드 초기화 //
  useEffect(() => {
    if (imgBase64 !== '') {
      setIsUpLoad(true);
      setIsErrorProfile(false);
    }
  }, [imgBase64])

  const handleClick = (e) => {
    hiddenFileInput.current.click();
  };
  
  const handleChange = (e) => { 
    var pathpoint = e.target.value.lastIndexOf('.');
    var filepoint = e.target.value.substring(pathpoint + 1, e.target.length);
    var filetype = filepoint.toLowerCase();

    if (filetype === 'jpg' || filetype === 'png' || filetype === 'jpeg') {

      // 정상적인 이미지 확장자 파일인 경우

    } 
    else {
      alert(t('memberRegistration.profileInput.invalidFileType'));
      var parentObj = e.target.parentNode
      var node = parentObj.replaceChild(e.target.cloneNode(true), e.target);

      return false;
    }

    const reader = new FileReader();
    var tmp = e.target.value.split('\\');
    setImgLocalPath(tmp[tmp.length - 1]);
    
    reader.onloadend = () => {
      const base64 = reader.result;
      if (base64){
        setImgBase64(base64.toString());
        setIsUpLoad(true);
      }
    };
    if (e.target.files[0]) {
      reader.readAsDataURL(e.target.files[0]);
      setImgFile(e.target.files[0]);
    }
  };

  function onError() {
    setIsErrorProfile(true);
  }

  function decideUserProfile() {
    if (isErrorProfile) return DefaultLogoPath;
    else if (imgFile) return URL.createObjectURL(imgFile);
    else if (isUpLoad) return imgBase64;
    else return DefaultLogoPath;
  }
  
  return (
    <TopLevelWrapper>
      <TotalWrapper>
        <LogoWrapper>
          <Logo src={decideUserProfile()} onError={onError} $isDefault={isErrorProfile || (!imgFile && !isUpLoad)} />
          <EditIconWrapper onClick={handleClick}>
            <EditSvg width={16} height={16} />
          </EditIconWrapper>
          <input
            type="file"
            ref={hiddenFileInput}
            onChange={handleChange}
            style={{ display: 'none' }} />
        </LogoWrapper>
        {/* <InputWrapper>
          <input type="file"
            ref={hiddenFileInput}
            onChange={handleChange}
            style={{ display: 'none' }} />
          <FileInput ref={FileInputRef}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={imgLocalPath === '' ? '#DBDBDB' : '#000000'} cursor='pointer'>{imgLocalPath === '' ? t('memberRegistration.profileInput.uploadPhotoPlaceholder') : imgLocalPath}</Text>
          </FileInput>
        </InputWrapper>
        <InputButton onClick={handleClick}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={12} color='#FFFFFF' cursor='pointer'>{t('memberRegistration.profileInput.changePhoto')}</Text>
        </InputButton> */}
      </TotalWrapper>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
`;

const FileInput = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 5px 8px;

  width: 182px;
  height: 20px;
  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;

  overflow: hidden;

  transition: all 0.5s ease-in-out;
`;

const InputButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 55px;
  height: 32px;

  border-radius: 5px;
  background-color: ${props => props.theme.line};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const LogoWrapper = styled.div`
  position: relative;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  width: 107px;
  height: 107px;
  box-sizing: border-box;

  background: #FDFCFB;
  border-radius: 5px;

  overflow: hidden;
`;

const Logo = styled.img`
  width: ${props => props.$isDefault ? '74.86px' : '100%'};
  height: ${props => props.$isDefault ? '74.8px' : '100%'};

  object-fit: ${props => props.$isDefault ? 'contain' : 'cover'};
`;

const EditIconWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 26px;
  height: 26px;

  top: 0;
  left: 81px;

  background: rgba(0, 0, 0, 0.2);
  border-radius: 0px 0px 0px 5px;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }

  & path {
    fill: ${({ theme }) => theme.white};
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  margin: 0 0 0 0;

  color: ${props => props.color};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;